// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.button__addcomplaint {
  width: 90px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__addcomplaint.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__addcomplaint {
    width: auto;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__new-complaint {
  width: 90px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__new-complaint.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__new-complaint {
    width: auto;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__work-complaint {
  width: 100px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 10px;
}
.button__work-complaint.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__work-complaint {
    width: auto;
    height: 20px;
    font-size: 10px;
    margin-right: 5px;
  }
}

.button__closed-complaint {
  width: 100px;
  height: 30px;
  border: 1px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.button__closed-complaint.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button__closed-complaint {
    width: auto;
    height: 20px;
    font-size: 10px;
  }
}

.inactive {
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529; /* Черный текст для неактивной кнопки */
}

@media (max-width: 460px) {
  .complaint-table {
    width: auto;
  }
}

.complaint-thead__number {
  width: 150px;
  text-align: center;
}
.complaint-thead__name {
  width: 200px;
  text-align: center;
}
.complaint-thead__date {
  width: 150px;
  text-align: center;
}
.complaint-thead__closed {
  width: 200px;
  text-align: center;
}
.complaint-thead__delete {
  width: 100px;
  text-align: center;
}

.complaint-info__content {
  margin-top: 25px;
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.complaint-info__image img {
  display: block;
  margin: 0 auto;
  height: 200px;
  border-radius: 10px;
}
@media (max-width: 575px) {
  .complaint-info__image img {
    width: 450px;
    height: 150px;
  }
}
@media (max-width: 470px) {
  .complaint-info__image img {
    width: 400px;
  }
}
@media (max-width: 410px) {
  .complaint-info__image img {
    width: 350px;
  }
}
.complaint-info__information {
  margin-top: 25px;
  display: flex;
  justify-content: center;
}
.complaint-info__number, .complaint-info__name {
  font-size: 22px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  padding-right: 15px;
}
@media (max-width: 575px) {
  .complaint-info__number, .complaint-info__name {
    font-size: 18px;
  }
}
@media (max-width: 460px) {
  .complaint-info__number, .complaint-info__name {
    font-size: 16px;
    padding-right: 7px;
  }
}
.complaint-info__date {
  font-size: 22px;
  font-weight: 400;
  color: rgb(7, 7, 7);
}
@media (max-width: 575px) {
  .complaint-info__date {
    font-size: 18px;
  }
}
@media (max-width: 460px) {
  .complaint-info__date {
    font-size: 16px;
  }
}
.complaint-info__filter {
  margin-top: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .complaint-info__filter-card {
    overflow-x: auto;
  }
}
.complaint-info__filter-card__content {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 460px) {
  .complaint-info__filter-card__content {
    width: auto;
  }
}
.complaint-info__filter-card__item {
  font-size: 18px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  cursor: pointer;
  padding: 10px 20px;
  border-radius: 10px;
  list-style: none;
  transition: background-color 0.1s ease-in-out;
}
@media (max-width: 768px) {
  .complaint-info__filter-card__item {
    white-space: nowrap;
  }
}
@media (max-width: 575px) {
  .complaint-info__filter-card__item {
    font-size: 14px;
    padding: 10px 15px;
  }
}
@media (max-width: 500px) {
  .complaint-info__filter-card__item {
    padding: 5px 12px;
  }
}
@media (max-width: 450px) {
  .complaint-info__filter-card__item {
    padding: 5px 13px;
  }
}
@media (max-width: 450px) {
  .complaint-info__filter-card__item {
    padding: 5px 12px;
  }
}
@media (max-width: 400px) {
  .complaint-info__filter-card__item {
    font-size: 13px;
  }
}
.complaint-info__filter-card__item:hover {
  background-color: #23232d;
  color: white;
}
.complaint-info__filter-card__item:active {
  background-color: #1c1d25;
}
.complaint-info__filter-card__item.active {
  background-color: #1c1d25;
  color: white;
}
.complaint-info .cabinet__item {
  font-size: 22px;
  font-weight: 400;
  color: #0000ff;
  padding-right: 15px;
  cursor: pointer;
}
.complaint-info .cabinet__item:hover {
  color: #f80000;
}
@media (max-width: 575px) {
  .complaint-info .cabinet__item {
    font-size: 18px;
    padding-top: 20px;
  }
}
.complaint-info .information {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.complaint-info .information__content {
  margin: 25px 0px 15px 0px;
  padding: 20px;
  width: 800px;
  min-height: 200px;
  border-radius: 10px;
  border: 2px solid #9da1aa;
}
@media (max-width: 810px) {
  .complaint-info .information__content {
    width: 700px;
  }
}
@media (max-width: 710px) {
  .complaint-info .information__content {
    width: 600px;
  }
}
@media (max-width: 610px) {
  .complaint-info .information__content {
    width: 500px;
  }
}
@media (max-width: 510px) {
  .complaint-info .information__content {
    width: 400px;
  }
}
@media (max-width: 410px) {
  .complaint-info .information__content {
    width: 380px;
  }
}
@media (max-width: 380px) {
  .complaint-info .information__content {
    width: 360px;
  }
}
@media (max-width: 360px) {
  .complaint-info .information__content {
    width: 340px;
  }
}
@media (max-width: 340px) {
  .complaint-info .information__content {
    width: 319px;
  }
}
.complaint-info .information__field {
  font-size: 19px;
  font-weight: 400;
  color: rgb(7, 7, 7);
  font-family: "Open Sans", sans-serif;
  white-space: pre-wrap; /* сохраняет абзацы и переносит текст по словам */
  word-break: break-word;
}
@media (max-width: 1024px) {
  .complaint-info .information__field {
    white-space: pre-wrap;
  }
}
@media (max-width: 768px) {
  .complaint-info .information__field {
    font-size: 16px;
  }
}
@media (max-width: 480px) {
  .complaint-info .information__field {
    font-size: 14px;
  }
}
.complaint-info .information__show {
  font-size: 17px;
  font-weight: 400;
  color: #7d7f7d;
  text-align: center;
  cursor: pointer;
}
@media (max-width: 768px) {
  .complaint-info .information__show {
    font-size: 14px;
  }
}
.complaint-info .images {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 25px;
}
.complaint-info .images__content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 10px;
  grid-row-gap: 20px;
  margin-bottom: 30px;
}
@media (max-width: 460px) {
  .complaint-info .images__content {
    grid-template-columns: repeat(1, 1fr);
  }
}
.complaint-info .images__image {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
@media (max-width: 460px) {
  .complaint-info .images__image {
    margin-top: 25px;
  }
}
.complaint-info .images__image img {
  width: 350px;
  height: 250px;
  margin-bottom: 15px;
}
@media (max-width: 1100px) {
  .complaint-info .images__image img {
    width: 300px;
  }
}
@media (max-width: 950px) {
  .complaint-info .images__image img {
    width: 260px;
    height: 200px;
  }
}
@media (max-width: 800px) {
  .complaint-info .images__image img {
    width: 230px;
    height: 180px;
  }
}
@media (max-width: 700px) {
  .complaint-info .images__image img {
    width: 200px;
    height: 150px;
  }
}
@media (max-width: 620px) {
  .complaint-info .images__image img {
    width: 190px;
    height: 150px;
  }
}
@media (max-width: 611px) {
  .complaint-info .images__image img {
    width: 350px;
    height: 250px;
  }
}
@media (max-width: 380px) {
  .complaint-info .images__image img {
    width: 300px;
  }
}
.complaint-info .images__delete {
  font-size: 18px;
  font-weight: 400;
  color: red;
  cursor: pointer;
}

.modal__text {
  font-size: 17px;
  font-weight: 500;
  color: #212529;
}`, "",{"version":3,"sources":["webpack://./src/components/Complaint/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;AADI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAGR;AADI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAIN;AACF;;AADA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAIJ;AAHI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAKR;AAHI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAMN;AACF;;AAFA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAKJ;AAJI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAMR;AAJI;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAON;AACF;;AAHA;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAMJ;AALI;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAOR;AALI;EAdJ;IAeQ,WAAA;IACA,YAAA;IACA,eAAA;EAQN;AACF;;AALA;EACI,yBAAA,EAAA,oCAAA;EACA,cAAA,EAAA,uCAAA;AAQJ;;AAFI;EADJ;IAEQ,WAAA;EAMN;AACF;;AAFI;EACI,YAAA;EACA,kBAAA;AAKR;AAHI;EACI,YAAA;EACA,kBAAA;AAKR;AAHI;EACI,YAAA;EACA,kBAAA;AAKR;AAHI;EACI,YAAA;EACA,kBAAA;AAKR;AAHI;EACI,YAAA;EACA,kBAAA;AAKR;;AAEI;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACR;AAEQ;EACI,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAAZ;AACY;EALJ;IAMQ,YAAA;IACA,aAAA;EAEd;AACF;AADY;EATJ;IAUQ,YAAA;EAId;AACF;AAHY;EAZJ;IAaQ,YAAA;EAMd;AACF;AADI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;AAGR;AACI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AACR;AAAQ;EALJ;IAMQ,eAAA;EAGV;AACF;AAFQ;EARJ;IASQ,eAAA;IACA,kBAAA;EAKV;AACF;AAFI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAIR;AAHQ;EAJJ;IAKQ,eAAA;EAMV;AACF;AALQ;EAPJ;IAQQ,eAAA;EAQV;AACF;AALI;EACI,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAOR;AAHW;EAFH;IAGI,gBAAA;EAMV;AACF;AAHY;EACI,aAAA;EACA,8BAAA;AAKhB;AAJgB;EAHJ;IAIQ,WAAA;EAOlB;AACF;AAHY;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;AAKhB;AAJgB;EATJ;IAUQ,mBAAA;EAOlB;AACF;AANgB;EAZJ;IAaQ,eAAA;IACA,kBAAA;EASlB;AACF;AARgB;EAhBJ;IAiBQ,iBAAA;EAWlB;AACF;AAVgB;EAnBJ;IAoBQ,iBAAA;EAalB;AACF;AAZgB;EAtBJ;IAuBQ,iBAAA;EAelB;AACF;AAdgB;EAzBJ;IA0BQ,eAAA;EAiBlB;AACF;AAfgB;EACE,yBAAA;EACA,YAAA;AAiBlB;AAdgB;EACE,yBAAA;AAgBlB;AAZgB;EACI,yBAAA;EACA,YAAA;AAcpB;AAPQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AASZ;AARY;EACI,cAAA;AAUhB;AARY;EATJ;IAUQ,eAAA;IACA,iBAAA;EAWd;AACF;AAHI;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAKR;AAFQ;EACI,yBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AAIZ;AAHY;EAPJ;IAQQ,YAAA;EAMd;AACF;AALY;EAVJ;IAWQ,YAAA;EAQd;AACF;AAPY;EAbJ;IAcQ,YAAA;EAUd;AACF;AATY;EAhBJ;IAiBQ,YAAA;EAYd;AACF;AAXY;EAnBJ;IAoBQ,YAAA;EAcd;AACF;AAbY;EAtBJ;IAuBQ,YAAA;EAgBd;AACF;AAfY;EAzBJ;IA0BQ,YAAA;EAkBd;AACF;AAjBY;EA5BJ;IA6BQ,YAAA;EAoBd;AACF;AAhBQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA,EAAA,iDAAA;EACA,sBAAA;AAkBZ;AAjBY;EAPJ;IAQQ,qBAAA;EAoBd;AACF;AAnBY;EAVJ;IAWQ,eAAA;EAsBd;AACF;AArBY;EAbJ;IAcQ,eAAA;EAwBd;AACF;AArBQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAuBZ;AAtBY;EANJ;IAOQ,eAAA;EAyBd;AACF;AApBI;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AAsBR;AApBQ;EACI,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAsBZ;AArBY;EAPJ;IAQQ,qCAAA;EAwBd;AACF;AArBQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAuBZ;AAtBY;EALJ;IAMQ,gBAAA;EAyBd;AACF;AAvBY;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAyBhB;AAxBgB;EAJJ;IAKQ,YAAA;EA2BlB;AACF;AA1BgB;EAPJ;IAQQ,YAAA;IACA,aAAA;EA6BlB;AACF;AA5BgB;EAXJ;IAYQ,YAAA;IACA,aAAA;EA+BlB;AACF;AA9BgB;EAfJ;IAgBQ,YAAA;IACA,aAAA;EAiClB;AACF;AAhCgB;EAnBJ;IAoBQ,YAAA;IACA,aAAA;EAmClB;AACF;AAlCgB;EAvBJ;IAwBQ,YAAA;IACA,aAAA;EAqClB;AACF;AApCgB;EA3BJ;IA4BQ,YAAA;EAuClB;AACF;AAnCQ;EACI,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AAqCZ;;AA9BA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAiCJ","sourcesContent":[".button__addcomplaint {\n    width: 90px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: auto;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n    }\n}\n\n.button__new-complaint {\n    width: 90px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: auto;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n        \n    }\n}\n\n.button__work-complaint {\n    width: 100px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    margin-right: 10px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: auto;\n        height: 20px;\n        font-size: 10px;\n        margin-right: 5px;\n        \n    }\n}\n\n.button__closed-complaint {\n    width: 100px;\n    height: 30px;\n    border: 1px solid #212529;\n    background-color: #212529;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    &.active {\n        background-color: #212529; /* Черный фон для активной кнопки */\n        color: #ffffff; /* Белый текст для активной кнопки */\n    }\n    @media(max-width: 460px) {\n        width: auto;\n        height: 20px;\n        font-size: 10px;\n    }\n}\n\n.inactive {\n    background-color: #ffffff; /* Белый фон для неактивной кнопки */\n    color: #212529; /* Черный текст для неактивной кнопки */\n}\n\n\n//complaint table \n.complaint-table {\n    @media(max-width: 460px) {\n        width: auto;\n    }\n    \n}\n.complaint-thead {\n    &__number {\n        width: 150px;\n        text-align: center;\n    }\n    &__name {\n        width: 200px;\n        text-align: center;\n    }\n    &__date {\n        width: 150px;\n        text-align: center;\n    }\n    &__closed {\n        width: 200px;\n        text-align: center;\n    }\n    &__delete {\n        width: 100px;\n        text-align: center;\n    }\n}\n\n\n//complaint-info \n.complaint-info  {\n    &__content {\n        margin-top: 25px;\n        margin-bottom: 25px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    &__image {\n        img {\n            display: block;\n            margin: 0 auto;\n            height: 200px;\n            border-radius: 10px;\n            @media(max-width: 575px) {\n                width: 450px;\n                height: 150px;\n            }\n            @media(max-width: 470px) {\n                width: 400px;\n            }\n            @media(max-width: 410px) {\n                width: 350px;\n            }\n        }  \n\n    }\n\n    &__information {\n        margin-top: 25px;\n        display: flex;\n        justify-content: center;\n        \n    } \n\n    &__number, &__name{\n        font-size: 22px;\n        font-weight: 400;\n        color: rgb(7, 7, 7);\n        padding-right: 15px;\n        @media(max-width: 575px) {\n            font-size: 18px;\n        }\n        @media(max-width: 460px) {\n            font-size: 16px;\n            padding-right: 7px;\n        }\n    }\n\n    &__date {\n        font-size: 22px;\n        font-weight: 400;\n        color: rgb(7, 7, 7);\n        @media(max-width: 575px) {\n            font-size: 18px;\n        }\n        @media(max-width: 460px) {\n            font-size: 16px;\n        }\n    }\n\n    &__filter {\n        margin-top: 25px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &-card {\n            \n           @media(max-width: 768px){\n            overflow-x: auto;\n           }\n            \n\n            &__content {\n                display: flex;\n                justify-content: space-between;\n                @media(max-width: 460px) {\n                    width: auto;\n                }\n                \n            }\n\n            &__item {\n                font-size: 18px;\n                font-weight: 400;\n                color: rgb(7,7,7);\n                cursor: pointer;\n                padding: 10px 20px;\n                border-radius: 10px;\n                list-style: none;\n                transition: background-color 0.1s ease-in-out;\n                @media(max-width: 768px) {\n                    white-space: nowrap\n                }\n                @media(max-width: 575px) {\n                    font-size: 14px;\n                    padding: 10px 15px;\n                }\n                @media (max-width: 500px) {\n                    padding: 5px 12px;\n                }\n                @media (max-width: 450px) {\n                    padding: 5px 13px;\n                }\n                @media (max-width: 450px) {\n                    padding: 5px 12px;\n                }\n                @media (max-width: 400px) {\n                    font-size: 13px;\n                }\n          \n                &:hover {\n                  background-color: darken(#272833, 2%);\n                  color: #ffff;\n                }\n          \n                &:active {\n                  background-color: darken(#272833, 5%);\n                 \n                }\n          \n                &.active {\n                    background-color: darken(#272833, 5%);\n                    color: #ffff;\n                  }\n            }\n        }\n    }\n\n    .cabinet {\n        &__item {\n            font-size: 22px;\n            font-weight: 400;\n            color: #0000ff;\n            padding-right: 15px;\n            cursor: pointer;\n            &:hover {\n                color: #f80000;\n            }\n            @media(max-width: 575px) {\n                font-size: 18px;\n                padding-top: 20px;\n            }\n\n\n        }\n    }\n\n    // information\n\n    .information {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        align-items: center;\n       \n\n        &__content {\n            margin: 25px 0px 15px 0px;\n            padding: 20px;\n            width: 800px;\n            min-height: 200px;\n            border-radius: 10px;\n            border: 2px solid #9da1aa;\n            @media(max-width: 810px) {\n                width: 700px;\n            }\n            @media(max-width: 710px) {\n                width: 600px;\n            }\n            @media(max-width: 610px) {\n                width: 500px;\n            }\n            @media(max-width: 510px) {\n                width: 400px;\n            }\n            @media(max-width: 410px) {\n                width: 380px;\n            }\n            @media(max-width: 380px) {\n                width: 360px;\n            }\n            @media(max-width: 360px) {\n                width: 340px;\n            }\n            @media(max-width: 340px) {\n                width: 319px;\n            }\n            \n        }\n\n        &__field {\n            font-size: 19px;\n            font-weight: 400;\n            color: rgb(7,7,7);\n            font-family: \"Open Sans\", sans-serif;\n            white-space: pre-wrap; /* сохраняет абзацы и переносит текст по словам */\n            word-break: break-word;\n            @media(max-width: 1024px) {\n                white-space: pre-wrap;\n            }\n            @media(max-width: 768px) {\n                font-size: 16px;\n            }\n            @media(max-width: 480px) {\n                font-size: 14px;\n            }\n        }\n\n        &__show {\n            font-size: 17px;\n            font-weight: 400;\n            color: #7d7f7d;\n            text-align: center;\n            cursor: pointer;\n            @media(max-width: 768px) {\n                font-size: 14px;\n            }\n        }\n    }\n\n    //images \n    .images {\n        display: flex;\n        justify-content: center;\n        flex-direction: column;\n        align-items: center;\n        margin-top: 25px;\n\n        &__content {\n            display: grid;\n            grid-template-columns: repeat(3, 1fr);\n            grid-template-rows: 1fr;\n            grid-column-gap: 10px;\n            grid-row-gap: 20px;\n            margin-bottom: 30px;\n            @media(max-width: 460px) {\n                grid-template-columns: repeat(1, 1fr);\n            }\n        }\n\n        &__image {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            @media(max-width: 460px) {\n                margin-top: 25px;\n            }\n            \n            img {\n                width: 350px;\n                height: 250px;\n                margin-bottom: 15px;\n                @media(max-width: 1100px) {\n                    width: 300px;\n                }\n                @media(max-width: 950px) {\n                    width: 260px;\n                    height: 200px;\n                }\n                @media(max-width: 800px) {\n                    width: 230px;\n                    height: 180px;\n                }\n                @media(max-width: 700px) {\n                    width: 200px;\n                    height: 150px;\n                }\n                @media(max-width: 620px) {\n                    width: 190px;\n                    height: 150px;\n                }\n                @media(max-width: 611px) {\n                    width: 350px;\n                    height: 250px;\n                }\n                @media(max-width: 380px) {\n                    width: 300px;\n                }\n            }\n        }\n\n        &__delete {\n            font-size: 18px;\n            font-weight: 400;\n            color: red;\n            cursor: pointer;\n        }\n    }\n}\n\n\n//modal \n.modal__text {\n    font-size: 17px;\n    font-weight: 500;\n    color: #212529;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
